// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ollama-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  max-width: 900px;
  margin: 0 auto;
  padding: 1.5rem 1.5rem 0;
  box-sizing: border-box;
}

.ollama-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-shrink: 0;
}

.ollama-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.25rem;
}

.ollama-subtitle {
  color: #718096;
  margin: 0;
  font-size: 0.9rem;
}

.ollama-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.ollama-model-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.9rem;
  background: white;
  cursor: pointer;
  color: #374151;
}

.ollama-clear-btn {
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.ollama-clear-btn:hover { background: #f3f4f6; }

.ollama-error {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #dc2626;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  flex-shrink: 0;
}

/* ── Messages ────────────────────────────────────────────── */
.ollama-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.5rem 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ollama-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #9ca3af;
  text-align: center;
  gap: 0.5rem;
}
.ollama-empty-icon { font-size: 3rem; }
.ollama-empty p { margin: 0; font-size: 1rem; }
.ollama-empty-hint { font-size: 0.8rem !important; color: #d1d5db; }
.ollama-web-hint { color: #60a5fa !important; }

.ollama-message {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.ollama-message--user {
  flex-direction: row-reverse;
}

.ollama-message-avatar {
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.ollama-message-bubble {
  max-width: 80%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  line-height: 1.5;
}

.ollama-message--user .ollama-message-bubble {
  background: #3b82f6;
  color: white;
  border-bottom-right-radius: 4px;
}

.ollama-message--assistant .ollama-message-bubble {
  background: #f3f4f6;
  color: #1a202c;
  border-bottom-left-radius: 4px;
}

.ollama-message-content {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 0.95rem;
}

/* ── Typing dots ─────────────────────────────────────────── */
.ollama-message-bubble--typing {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0.85rem 1.1rem;
}

.ollama-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #9ca3af;
  animation: ollama-bounce 1.2s infinite ease-in-out;
}
.ollama-dot:nth-child(2) { animation-delay: 0.2s; }
.ollama-dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes ollama-bounce {
  0%, 80%, 100% { transform: scale(0.8); opacity: 0.5; }
  40% { transform: scale(1.1); opacity: 1; }
}

/* ── Input area ──────────────────────────────────────────── */
.ollama-input-area {
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
  padding: 1rem 0 1.5rem;
  flex-shrink: 0;
  border-top: 1px solid #e5e7eb;
}

.ollama-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 0.95rem;
  font-family: inherit;
  resize: none;
  outline: none;
  line-height: 1.5;
  transition: border-color 0.15s;
}
.ollama-input:focus { border-color: #3b82f6; }
.ollama-input:disabled { background: #f9fafb; color: #9ca3af; }

.ollama-send-btn {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: none;
  background: #3b82f6;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ollama-send-btn:hover:not(:disabled) { background: #2563eb; }
.ollama-send-btn:disabled { background: #93c5fd; cursor: not-allowed; }

/* ── Web search toggle ───────────────────────────────────── */
.ollama-web-toggle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.85rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  font-size: 0.85rem;
  color: #6b7280;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  -webkit-user-select: none;
          user-select: none;
}
.ollama-web-toggle input { margin: 0; cursor: pointer; }
.ollama-web-toggle:hover { background: #f3f4f6; }
.ollama-web-toggle.active {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #1d4ed8;
}

/* ── Web search badges ───────────────────────────────────── */
.ollama-web-badge {
  font-size: 0.75rem;
  color: #1d4ed8;
  background: #dbeafe;
  border-radius: 4px;
  padding: 0.2rem 0.5rem;
  margin-bottom: 0.5rem;
  display: inline-block;
}

.ollama-searching {
  font-size: 0.8rem;
  color: #6b7280;
  font-style: italic;
  margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OllamaChat.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA,qBAAqB,eAAe,EAAE;AACtC,kBAAkB,SAAS,EAAE,eAAe,EAAE;AAC9C,qBAAqB,4BAA4B,EAAE,cAAc,EAAE;AACnE,mBAAmB,yBAAyB,EAAE;;AAE9C;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;AACA,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;;AAElD;EACE,gBAAgB,qBAAqB,EAAE,YAAY,EAAE;EACrD,MAAM,qBAAqB,EAAE,UAAU,EAAE;AAC3C;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;AACA,sBAAsB,qBAAqB,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,wCAAwC,mBAAmB,EAAE;AAC7D,4BAA4B,mBAAmB,EAAE,mBAAmB,EAAE;;AAEtE,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,2BAA2B,SAAS,EAAE,eAAe,EAAE;AACvD,2BAA2B,mBAAmB,EAAE;AAChD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".ollama-page {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 60px);\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 1.5rem 1.5rem 0;\n  box-sizing: border-box;\n}\n\n.ollama-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-shrink: 0;\n}\n\n.ollama-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 0.25rem;\n}\n\n.ollama-subtitle {\n  color: #718096;\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.ollama-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n.ollama-model-select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: white;\n  cursor: pointer;\n  color: #374151;\n}\n\n.ollama-clear-btn {\n  padding: 0.5rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: background 0.15s;\n  white-space: nowrap;\n}\n.ollama-clear-btn:hover { background: #f3f4f6; }\n\n.ollama-error {\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  color: #dc2626;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  flex-shrink: 0;\n}\n\n/* ── Messages ────────────────────────────────────────────── */\n.ollama-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.5rem 0 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.ollama-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #9ca3af;\n  text-align: center;\n  gap: 0.5rem;\n}\n.ollama-empty-icon { font-size: 3rem; }\n.ollama-empty p { margin: 0; font-size: 1rem; }\n.ollama-empty-hint { font-size: 0.8rem !important; color: #d1d5db; }\n.ollama-web-hint { color: #60a5fa !important; }\n\n.ollama-message {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-start;\n}\n\n.ollama-message--user {\n  flex-direction: row-reverse;\n}\n\n.ollama-message-avatar {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.ollama-message-bubble {\n  max-width: 80%;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n  line-height: 1.5;\n}\n\n.ollama-message--user .ollama-message-bubble {\n  background: #3b82f6;\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.ollama-message--assistant .ollama-message-bubble {\n  background: #f3f4f6;\n  color: #1a202c;\n  border-bottom-left-radius: 4px;\n}\n\n.ollama-message-content {\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: inherit;\n  font-size: 0.95rem;\n}\n\n/* ── Typing dots ─────────────────────────────────────────── */\n.ollama-message-bubble--typing {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0.85rem 1.1rem;\n}\n\n.ollama-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #9ca3af;\n  animation: ollama-bounce 1.2s infinite ease-in-out;\n}\n.ollama-dot:nth-child(2) { animation-delay: 0.2s; }\n.ollama-dot:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes ollama-bounce {\n  0%, 80%, 100% { transform: scale(0.8); opacity: 0.5; }\n  40% { transform: scale(1.1); opacity: 1; }\n}\n\n/* ── Input area ──────────────────────────────────────────── */\n.ollama-input-area {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-end;\n  padding: 1rem 0 1.5rem;\n  flex-shrink: 0;\n  border-top: 1px solid #e5e7eb;\n}\n\n.ollama-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  resize: none;\n  outline: none;\n  line-height: 1.5;\n  transition: border-color 0.15s;\n}\n.ollama-input:focus { border-color: #3b82f6; }\n.ollama-input:disabled { background: #f9fafb; color: #9ca3af; }\n\n.ollama-send-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  border: none;\n  background: #3b82f6;\n  color: white;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background 0.15s;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ollama-send-btn:hover:not(:disabled) { background: #2563eb; }\n.ollama-send-btn:disabled { background: #93c5fd; cursor: not-allowed; }\n\n/* ── Web search toggle ───────────────────────────────────── */\n.ollama-web-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.85rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  font-size: 0.85rem;\n  color: #6b7280;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n  user-select: none;\n}\n.ollama-web-toggle input { margin: 0; cursor: pointer; }\n.ollama-web-toggle:hover { background: #f3f4f6; }\n.ollama-web-toggle.active {\n  background: #eff6ff;\n  border-color: #3b82f6;\n  color: #1d4ed8;\n}\n\n/* ── Web search badges ───────────────────────────────────── */\n.ollama-web-badge {\n  font-size: 0.75rem;\n  color: #1d4ed8;\n  background: #dbeafe;\n  border-radius: 4px;\n  padding: 0.2rem 0.5rem;\n  margin-bottom: 0.5rem;\n  display: inline-block;\n}\n\n.ollama-searching {\n  font-size: 0.8rem;\n  color: #6b7280;\n  font-style: italic;\n  margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
